import * as React from "react";
import CCRODocumentPane from "../ccro/popups/ccro_document_pane";
import ParcelSpatialUnit from "../ccro/ccro_spatial_unit";
import ParcelRemark from "../ccro/ccro_remark_pane";
import ParcelInfo from "../ccro/ccro_parcel_info_pane";
import PartyInfo from "../ccro/ccro_party_info_pane";

export default class PlotDetailPane extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            tabs:[],
            current_tab:0,
            pane:<div>Loading...</div>
        }
        this.setPageAt = this.setPageAt.bind(this)
    }

    componentDidMount() {
        this.setState({
            tabs:[
                {name:'Spatial Unit',pane:<ParcelSpatialUnit screen_code={this.props.screen_code} taskId={this.props.taskId} parcel={this.props.parcel} />},
                {name:'Parcel Info',pane:<ParcelInfo screen_code={this.props.screen_code} taskId={this.props.taskId} parcel={this.props.parcel} key={new Date().getMilliseconds()}/>},
                {name:'Parties',pane:<PartyInfo screen_code={this.props.screen_code} taskId={this.props.taskId} parcel={this.props.parcel} key={new Date().getMilliseconds()}/>},
                {name:'Remarks',pane:<ParcelRemark screen_code={this.props.screen_code} taskId={this.props.taskId} parcel={this.props.parcel} key={new Date().getMilliseconds()}/>},
                {name:'Documents',pane:<CCRODocumentPane screen_code={this.props.screen_code} taskId={this.props.taskId} parcel={this.props.parcel} key={new Date().getMilliseconds()}/>}
            ]
        })


        setTimeout(()=>{
            this.setPageAt(0)
        },100)
    }

    setPageAt(i){
        try {
            this.setState({
                current_tab:i,
                pane:this.state.tabs[i].pane
            })
        }catch (e) {
            console.log(e)
        }
    }
    render() {
        return(<div style={{width:'100%',float:'left'}}>

            <div className={'col col-sm-12'}>
                {this.state.tabs.map((d,i)=>{
                    return(<div onClick={()=>this.setPageAt(i)} className={i===this.state.current_tab?'tab tab-active':'tab'} key={i}>{d.name}</div>)
                })}
            </div>
            <div style={{width:'100%',float:'left'}}>
                {this.state.pane}
            </div>

        </div>)
    }
}